export default __webpack_public_path__ + "static/media/icon_overview_pur_tip.87af72d1.svg";